import React, { useState } from "react";
import axios from "axios";
import Style from "../Style/Content.module.scss";
import { useOutletContext } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { motion } from "framer-motion";

const Content = () => {
  const { darkMode } = useOutletContext();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [success, setSuccess] = useState("");
  const baseURL = process.env.REACT_APP_BASE_URL;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${baseURL}/api/contact`, formData);
      if (res.status === 200) {
        setSuccess("✅ Inquiry submitted successfully!");
        setFormData({ name: "", email: "", message: "" });
      }
    } catch (error) {
      console.error("❌ Submission failed:", error);
      alert("Something went wrong! Please try again.");
    }
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        transition={{
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1],
        }}
      >
        <HelmetProvider>
          <Helmet>
            <title>Content</title>
            <link rel="canonical" href="content-us" />
          </Helmet>
        </HelmetProvider>
        <div className={`${Style.Content} ${darkMode ? Style.dark : ""}`}>
          <div className={Style.wrapper}>
            <div className={Style.ContentDisk}>
              <h2>CONTACT-US</h2>
            </div>
            <div className={Style.ContentInquery}>
              <div className={Style.ContentWrap}>
                <form onSubmit={handleSubmit} className={Style.inquiryForm}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  <textarea
                    name="message"
                    placeholder="Your Message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                  <button type="submit" className={Style.ContentButton}>
                    Send Inquiry
                  </button>
                  {success && <p className={Style.success}>{success}</p>}
                </form>
              </div>
              <div className={Style.mapContainer}>
                <h3>Our Location</h3>
                <iframe
                  title="Google Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28025.102922236725!2d77.41910669722736!3d28.595640624910782!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cef1371f701a3%3A0xfc74584819940721!2sNirala%20Aspire!5e0!3m2!1sen!2sin!4v1754436746601!5m2!1sen!2sin"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Content;
